import * as Database from './db';
import * as Lambda from './LambdaApi';

const userAlreadyExists = async username => {
    try {
        const apiPath = `/registrations/users/${username}`;
        const userAlreadyExists = await Lambda.Get(apiPath, {}, 'lambda');
        if (userAlreadyExists.success) return true;
        return false;
    } catch (error) {
        throw Error(error);
    }
};

const tokenToPermanentConnection = async (Token, RegistrantId) => {
    try {
        const permanentConnectionResponse = await Database.createPermanentConnection(Token, RegistrantId);
        return true;
    } catch (error) {
        throw Error(error);
    }
};

const getTempLogCredentials = async code => {
    try {
        const apiPath = `/registrations/temp-credentials`;
        const userTempCreds = await Lambda.Get(
            apiPath, {
                queryStringParameters: {
                    userCode: code
                }
                }, 'public'
        )

        if (userTempCreds.success) return userTempCreds.creds;

        return false

    } catch (error) {
        // throw Error(error)
        return false
    }
}

export { tokenToPermanentConnection, userAlreadyExists,getTempLogCredentials};
